import React from 'react'
import TableHeadRow from './TableHeadRow'
import Selection from './Selection'
import {conIdMatchingObj} from '../helper'


function TableHead({ handleSort, sortOrder, sortColumn, arr, label, handleChange, selectConnStatus , select}) {

  //create table headers based on the API get response
  const tableHeadersObject = [
    {head:'#',value:'#'},
    {head:'ID', value:'id'}, 
    {head:'Location', value:'location'},
    {head:'Voltage', value:'voltage'} ,
    {head:'Capacity',value:'capacity'}, 
    {head:'Connection Status',value:'connectionStatus' },
    {head:'Last ConnectionTime', value:'lastConnectionTime'},
    {head:'Charge State', value:'stateOfCharge'}, 
    {head:'Health State',value:'stateOfHealth'},
    {head:'Recent Issues', value:'recentIssues'}
  ]

  //get connection status Id array from connection status matching helper object 
  const connStatusHeaderArray = Object.entries(conIdMatchingObj)
 


/*   const tableHeadersValues = ['id', 'id', 'location', 'voltage' ,'capacity', 'connectionStatus', 'connectionStatusId', 'lastConnectionTime','stateOfCharge', 'stateOfHealth','recentIssues']
 */  
  return (
    <thead>
        <tr> 
            {
                //table headers from the array 
                tableHeadersObject.map((head) => (
                    head.head === 'Location' ? 
                    <th key={head.head} value={head.value}>
                        {head.head} 
                          <Selection 
                            arr={arr}
                            handleChange={handleChange}
                            label={label}
                            selected={select}
                          /> 
                       
                    </th>
                    :
                    head.head === 'Connection Status' ? 
                    <th key={head.head} value={head.value}>
                        {head.head} 
                          <Selection 
                            arr={connStatusHeaderArray}
                            handleChange={handleChange}
                            label="connstatus"
                            selected={selectConnStatus}
                          /> 
                       
                    </th>
                    :
                    <TableHeadRow
                        key={head.head}
                        value={head.value}
                        name={head.head}
                        sortOrder={sortOrder}
                        sortColumn={head.value === sortColumn}
                        handleSort={handleSort}
                    />
                ))
            }
        </tr>
    </thead>
  )
}

export default TableHead